const { __ } = wp.i18n;
const { Component,useState,useEffect } = wp.element;
const { withSelect, useSelect} = wp.data;
const { SelectControl, FormTokenField } = wp.components;


class StyleSelector extends Component {
  render() {
    const {
      value,
      label,
      options,
      columns = 2,
      className,
      onChange,
    } = this.props;

    return (
      <div
        className={`easy_email_integration-field easy_email_integration-field-layout ${
          className ? className : ''
        }`}
      >
        {label && (
          <span className="easy_email_integration-field-label">{label}</span>
        )}
        <div className="easy_email_integration-field-content easy_email_integration-field-layout-list">
          {options.map((data, index) => {
            return (
              <div
                key={index}
                onClick={() => onChange(data.value)}
                className={`${value == data.value ? 'active' : ''}`}
              >
                {data.styleIcon && (
                  <span
                    className={`easy_email_integration-layout-style easy_email_integration-layout-style-${data.value}`}
                  >
                    {data.styleIcon === 1 && (
                      <span className="eei-skeleton">
                        <span className="eei-sk text small"></span>
                        <span className="eei-sk text mb1"></span>
                        <span className="eei-sk"></span>
                        <span className="eei-sk mb1"></span>
                        <span className="eei-sk ws"></span>
                      </span>
                    )}
                    {data.styleIcon === 2 && (
                      <span className="eei-skeleton">
                        <span className="eei-sk text left"></span>
                        <span className="eei-sk text small mb1 left"></span>
                        <span className="eei-sk flex big">
                          <span className="eei-sk left big flex-2"></span>
                          <span className="eei-sk left big yellow"></span>
                        </span>
                      </span>
                    )}
                    {data.styleIcon === 3 && (
                      <span className="eei-skeleton p0">
                        <span className="eei-sk split bgw">
                          <span className="eei-sk text"></span>
                          <span className="eei-sk text smallfull"></span>
                          <span className="eei-sk text smallfull"></span>
                          <span className="eei-sk text small"></span>
                        </span>
                        <span className="eei-sk split bg0">
                          <span className="eei-sk"></span>
                          <span className="eei-sk yellow"></span>
                        </span>
                      </span>
                    )}
                    {data.styleIcon === 4 && (
                      <span className="eei-skeleton">
                        <span className="eei-sk vsplit">
                          <span className="eei-sk image"></span>
                          <span className="eei-sk vline"></span>
                          <span className="eei-sk transparent">
                            <span className="eei-sk left text small"></span>
                            <span className="eei-sk left text full"></span>
                            <span className="eei-sk left text full"></span>
                            <span className="eei-sk left text mb1"></span>
                            <span className="eei-sk left big  border withsubmit"></span>
                          </span>
                        </span>
                      </span>
                    )}
                    {data.styleIcon === 5 && (
                      <span className="eei-skeleton p1">
                        <span className="eei-sk vsplit">
                          <span className="eei-sk transparent">
                            <span className="eei-sk left text black"></span>
                            <span className="eei-sk left text smallfull black"></span>
                            <span className="eei-sk left text smallfull black"></span>
                            <span className="eei-sk left text small mb1 black"></span>
                            <span className="eei-sk left border black"></span>
                            <span className="eei-sk yellow"></span>
                          </span>
                          <span className="eei-sk image black"></span>
                        </span>
                      </span>
                    )}
                  </span>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

class FlexSelector extends Component {
  render() {
    const { value, label, options, onChange, className } = this.props;
    return (
      <div className={`components-base-control ${className ? className : ''}`}>
        <div className="components-base-control__field">
          {label && (
            <label className="components-base-control__label">{label}</label>
          )}
          <div className="eei-flexselect">
            {options.map((option) => (
              <button
                className={option.value === value ? 'active' : ''}
                onClick={() => onChange(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
/**
 * Rediraction of page after submit of form
 */
const PageSelect = withSelect((select) => {
  return {
    posts: select('core').getEntityRecords('postType', 'page'),
  };
})(function (props) {
  const { label, posts, onChange, value } = props;
  var options = [];
  if (posts) {
    options.push({ value: 0, label: __('Select page', 'easy-email-integration') });
    props.posts.forEach((post) => {
      options.push({ value: post.link, label: post.title.rendered });
    });
  } else {
    options.push({ value: 0, label: __('Loading...', 'easy-email-integration') });
  }

  return (
    <SelectControl
      label={label}
      value={value}
      options={options}
      onChange={(val) => onChange(val)}
    />
  );
});
/**
 * Auto suggested dynamic Tag
 */
const PagesTags = withSelect((select) => {
 
  return {
    posts: select('core').getEntityRecords('taxonomy', 'post_tag' ),
  };
})(function (props) {
  const [ tags, setTags ] = useState( [] )

  useEffect(() => {
		loadTags();
	}, []);
  const loadTags = async () => {
		const response = await fetch(`${easy_email_integration.ajaxurl}/eei/v1/formtags`);
		if (response.status !== "error") {
			const data = await response.json();
			setTags(data);
		} else {
			console.log("Sorry, there was some error loading tags");
		}
	};

  const { label, posts, onChange, value } = props;
  let options = [];
  if (posts) {

    options = posts.map( value => value.name )

  } else {
    options.push({ value: 0, label: __('Loading...', 'easy-email-integration') });
  }

  return (
    <FormTokenField
    label={label}
    value={value}
    suggestions={ options }
    onChange={(val) => onChange(val)}
    />
  );
});

export const capitalizeWords = (string) => {
  string = string.replace('_', ' ');
  return string.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};

wp.easy_email_integrationComponent = {
  StyleSelector,
  PageSelect,
  FlexSelector,
  PagesTags
};
